import React, { useEffect, useState } from 'react';

import {
  Tr,
  Td,
  TdPrice,
  PriceLabel,
  PriceContent,
  LabelWrapper,
  PriceWrapper,
  ButtonWrapper,
  SVGWrapper,
  CheckBoxWrapper,
  StyledCheckBox,
  CheckBoxLabel,
  InputWrapper,
  InputContainer,
  InputLabel,
  RequiredLabel,
  AddRemoveButton,
  NoteLabel
} from './css';
import EditSVG from '../assets/svg/edit';
import CancelSVG from '../assets/svg/cancel';
import SaveSVG from '../assets/svg/save';
import {
  changePricing,
  changeQuantity,
  deleteQuantity,
  saveNewPricing,
  saveQuantity
} from './saveSchemaToDB';

const QuantityField = ({
  serviceId,
  quantityData,
  managedDetectionResponseData,
  setManagedDetectionResponseData,
  setSavingData
}) => {
  const {
    name: quantityLabel,
    note,
    id,
    isRequired,
    productCatalogPricing
  } = quantityData;

  const { id: pricingId, cost, onetimePrice } = productCatalogPricing;

  const [label, setLabel] = useState(quantityLabel);
  const [quantityCost, setQuantityCost] = useState(cost);
  const [quantityPrice, setQuantityPrice] = useState(onetimePrice);
  const [questionRequired, setQuestionRequired] = useState(isRequired);
  const [editMode, setEditMode] = useState(false);
  const [quantityNote, setQuantityNote] = useState(note);
  let quantityId = id;
  const handleCancel = () => {
    setLabel(quantityLabel);
    setQuantityNote(note);
    setQuestionRequired(isRequired);
    setQuantityCost(cost);
    setQuantityPrice(onetimePrice);
    setEditMode(false);
  };

  const handleSave = async () => {
    if (!label.trim()) return;
    const clonedAdminData = JSON.parse(
      JSON.stringify(managedDetectionResponseData)
    );
    const productCatalogQuantityField =
      clonedAdminData.productCatalogQuantities;
    if (productCatalogQuantityField.length === 0) {
      clonedAdminData.productCatalogQuantities.push({
        id: null,
        name: '',
        note: '',
        isRequired: false,
        serviceId,
        productCatalogPricing: {
          id: '',
          quantityId: '',
          cost: 0,
          onetimePrice: 0,
          operationType: 'ADD'
        }
      });
    }
    try {
      setSavingData(true);
      if (quantityId) {
        if (label.trim()) {
          await changeQuantity(quantityId, {
            name: label,
            isRequired: questionRequired,
            note: quantityNote
          });
          if (pricingId) {
            await changePricing(pricingId, {
              quantityId,
              cost: quantityCost,
              onetimePrice: quantityPrice
            });
          } else {
            pricingId = await saveNewPricing({
              quantityId,
              cost: quantityCost,
              onetimePrice: quantityPrice
            });
          }

          clonedAdminData.productCatalogQuantities[0].isRequired = questionRequired;
          clonedAdminData.productCatalogQuantities[0].name = label;
          clonedAdminData.productCatalogQuantities[0].note = quantityNote;
          clonedAdminData.productCatalogQuantities[0].id = quantityId;
          clonedAdminData.productCatalogQuantities[0].serviceId = serviceId;
          clonedAdminData.productCatalogQuantities[0].productCatalogPricing.cost = quantityCost;
          clonedAdminData.productCatalogQuantities[0].productCatalogPricing.onetimePrice = quantityPrice;
          clonedAdminData.productCatalogQuantities[0].productCatalogPricing.id = pricingId;
          clonedAdminData.productCatalogQuantities[0].productCatalogPricing.quantityId = quantityId;
        }
      } else if (label.trim()) {
        quantityId = await saveQuantity({
          name: label,
          serviceId,
          note: quantityNote,
          isRequired: questionRequired
        });

        const newPricingId = await saveNewPricing({
          quantityId,
          cost: quantityCost,
          onetimePrice: quantityPrice
        });

        clonedAdminData.productCatalogQuantities[0].id = quantityId;
        clonedAdminData.productCatalogQuantities[0].isRequired = questionRequired;
        clonedAdminData.productCatalogQuantities[0].name = label;
        clonedAdminData.productCatalogQuantities[0].note = quantityNote;

        clonedAdminData.productCatalogQuantities[0].serviceId = serviceId;
        clonedAdminData.productCatalogQuantities[0].productCatalogPricing.cost = quantityCost;
        clonedAdminData.productCatalogQuantities[0].productCatalogPricing.onetimePrice = quantityPrice;
        clonedAdminData.productCatalogQuantities[0].productCatalogPricing.id = newPricingId;
        clonedAdminData.productCatalogQuantities[0].productCatalogPricing.quantityId = quantityId;
      }
      setManagedDetectionResponseData(clonedAdminData);
    } catch {
      console.log('An error occurred while saving data');
      setSavingData(false);
    } finally {
      setEditMode(false);
      setSavingData(false);
    }
  };

  return (
    <Tr>
      <Td background="#f7f7f7">
        <LabelWrapper>
          {editMode ? (
            <InputWrapper>
              <InputContainer>
                <input
                  type="text"
                  style={{
                    width: '330px',
                    borderColor: label ? '#e4e4e4' : '#C12335'
                  }}
                  value={label}
                  onChange={e => setLabel(e.target.value)}
                />
                {!label.trim() && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>

              <CheckBoxWrapper>
                <StyledCheckBox
                  id="checkbox-id"
                  checked={questionRequired}
                  onChange={e => setQuestionRequired(e.target.checked)}
                />
                <CheckBoxLabel htmlFor="checkbox-id">Required</CheckBoxLabel>
              </CheckBoxWrapper>
              <InputContainer>
                <InputLabel>Note</InputLabel>
                <input
                  type="text"
                  style={{
                    width: '330px'
                  }}
                  value={quantityNote}
                  onChange={e => setQuantityNote(e.target.value)}
                />
              </InputContainer>
            </InputWrapper>
          ) : (
            <span>
              {label || '[Quantity label not added]'}
              {label && questionRequired ? '*' : ''}
              {note && <NoteLabel>{quantityNote}</NoteLabel>}
            </span>
          )}

          <ButtonWrapper>
            {editMode ? (
              <>
                <SVGWrapper onClick={handleCancel}>
                  <CancelSVG />
                </SVGWrapper>
                <SVGWrapper onClick={handleSave}>
                  <SaveSVG />
                </SVGWrapper>
              </>
            ) : (
              <SVGWrapper onClick={() => setEditMode(!editMode)}>
                <EditSVG />
              </SVGWrapper>
            )}
          </ButtonWrapper>
        </LabelWrapper>
      </Td>
      <Td>
        <input type="text" value="" placeholder={label} disabled />
      </Td>
      {editMode ? (
        <>
          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <input
                  type="text"
                  value={`${quantityCost}`}
                  style={{
                    borderColor: cost ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setQuantityCost(e.target.value)}
                />
                {!quantityCost && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
            </InputWrapper>
          </TdPrice>
          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <input
                  type="text"
                  value={`${quantityPrice}`}
                  style={{
                    borderColor: onetimePrice ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setQuantityPrice(e.target.value)}
                />
                {!quantityPrice && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
            </InputWrapper>
          </TdPrice>
        </>
      ) : (
        <>
          <Td>
            {quantityCost ? (
              <>
                <PriceWrapper>
                  <PriceContent>{`$${quantityCost}`}</PriceContent>
                </PriceWrapper>
              </>
            ) : (
              '-'
            )}
          </Td>
          <Td>
            {quantityPrice ? (
              <>
                <PriceWrapper>
                  <PriceContent>{`$${quantityPrice}`}</PriceContent>
                </PriceWrapper>
              </>
            ) : (
              '-'
            )}
          </Td>
        </>
      )}
    </Tr>
  );
};

export default QuantityField;
